import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisitPhotoTypes = async ({ trialId, visitId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();

  if (!!visitId) {
    params.append("visit_id", visitId);
  } else {
    params.append("trial_id", trialId);
  }

  const URL = `${__API_URL__}/api/photos/visit-photo-types/web/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useVisitPhotoTypes = ({ trialId, visitId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_photo_types", trialId, visitId],
    queryFn: () => fetchVisitPhotoTypes({ trialId, visitId }),
    enabled: enabled && Boolean(trialId && trialId > 0),
    refetchOnWindowFocus: false,
  });
};

export default useVisitPhotoTypes;
